import { API, Auth } from 'aws-amplify';

const API_NAME = 'AdminQueries';

interface Params {
  path: string;
  params?: any;
}

const getHeaders = async () => ({
  'Content-Type': 'application/json',
  Authorization: `${(await Auth.currentSession())
    .getAccessToken()
    .getJwtToken()}`,
});

const createParameters = async (params?: any) => ({
  headers: await getHeaders(),
  ...params,
});

export const adminQuery = {
  async get({ path, params }: Params) {
    const parameters = await createParameters(params);
    return await API.get(API_NAME, path, parameters);
  },
  async post({ path, params }: Params) {
    const parameters = await createParameters(params);
    return await API.post(API_NAME, path, parameters);
  },
};
